import {
  Checkbox,
  MenuItem,
  Select,
  TableCell
} from '@mui/material'
import { deleteRequest, postRequest } from 'utils/api'
import {
  FEATURE_STATUSES,
  USER_ALLOWED_FEATURE_URL,
} from 'services/constants'
import { useEffect, useState } from 'react'
import OverlayLoading from 'components/atoms/OverlayLoading'
import NotificationSnackBar from 'components/molecules/notificationOverlay/NotificationSnackBar'

const UserFeaturesSelectCell = ({ user, features, licensed = true }) => {
  const [requestError, setRequestError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [selectedFeatures, setSelectedFeatures] = useState([])
  const [displayFeatures, setDisplayFeatures] = useState([])
  const [snackBarOpen, setSnackBarOpen] = useState(false)

  useEffect(() => {
    let filteredFeatures = features
    if (!licensed) {
      filteredFeatures = features.filter(
        f => f.status === FEATURE_STATUSES.BETA
      )
    }
    setDisplayFeatures(filteredFeatures)
    const selectedIds = user?.allowedFeatures
      ?.filter(f => filteredFeatures.some(ff => ff.id === f.id))
      .map(f => f.id)
    setSelectedFeatures(selectedIds || [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = async updatedList => {
    setLoading(true)
    await Promise.all(
      displayFeatures.map(async f => {
        // Only add features that are not already selected
        if (
          updatedList.indexOf(f.id) > -1 &&
          selectedFeatures.indexOf(f.id) === -1
        ) {
          const res = await postRequest(USER_ALLOWED_FEATURE_URL, {
            userId: user.id,
            featureId: f.id
          })
          if (res.status === 200) {
            setRequestError(false)
          }
        } else if (
          updatedList.indexOf(f.id) === -1 &&
          selectedFeatures.indexOf(f.id) > -1
        ) {
          const res = await deleteRequest(USER_ALLOWED_FEATURE_URL, {
            userId: user.id,
            featureId: f.id
          })
          if (res.status === 204) {
            setRequestError(false)
          }
        }
      })
    )

    setSelectedFeatures(updatedList)
    setLoading(false)
  }
  return (
    <TableCell>
      {user.role && ( // No user role indicate out of organization user
        <Select
          size='small'
          multiple
          value={selectedFeatures}
          onChange={e => handleChange(e.target.value)}
          sx={{
            minWidth: '180px',
            width: '180px',
            padding: 0,
            '& .MuiOutlinedInput-input': {
              paddingTop: '0!important',
              paddingBottom: '0!important'
            }
          }}>
          {displayFeatures.map(option => (
            <MenuItem
              key={`licensed-features-option-${option.id}`}
              value={option.id}>
              <Checkbox checked={selectedFeatures.indexOf(option.id) > -1} />
              {option.name} - {option.status}
            </MenuItem>
          ))}
        </Select>
      )}
      <NotificationSnackBar
        open={snackBarOpen}
        setOpen={setSnackBarOpen}
        success={requestError === false}
        error={requestError}
      />

      <OverlayLoading open={loading} />
    </TableCell>
  )
}

export default UserFeaturesSelectCell
